module.exports = __webpack_public_path__ + "img/logo-er-1.7de9f982.png";